export const sortingCriteria = [
    {text: "Più recente", value: "lastModifiedAt"},
    {text: "Codice IMEI", value: "imei"},
    {text: "Descrizione", value: "descrizione"},
    {text: "Prodotto", value: "prodotto"},
];